import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Typography } from '@mui/material';

import * as orderActions from '../../../actions/order';
import diningChoiceEnum from '../../../enums/diningChoiceEnum';
import * as selectors from '../../../sagas/selectors';
import { isCustomMenuOrder } from '../../../utils/orderUtils';

import Button from '../../Button';
import ButtonsRow from '../../ButtonsRow/ButtonsRow';
import Modal from '../../Modal';

import './CustomMenuDiningChoiceModal.css';

function CustomMenuDiningChoiceModal() {
  const dispatch = useDispatch();

  const isStationFlow = useSelector(selectors.getIsStationFlow);
  const diningChoice = useSelector(selectors.getDiningChoice);
  const order = useSelector(selectors.getOrder);

  const [isModalOpen, setIsModalOpen] = useState(false);

  // NOTE: currently expects Custom Menu available at pick up orders/gglocation only
  useEffect(() => {
    if (
      (isStationFlow || diningChoice !== diningChoiceEnum.TAKE_AWAY) &&
      isCustomMenuOrder({ order })
    ) {
      setIsModalOpen(true);
    }
  }, [isStationFlow, diningChoice, order]);

  const clearCartClick = () => {
    dispatch(orderActions.resetOrder());
    setIsModalOpen(false);
  };

  const revertDiningChoice = () => {
    dispatch(
      orderActions.setDiningChoice({
        diningChoice: diningChoiceEnum.TAKE_AWAY,
        isStationFlow: false,
      }),
    );
    setIsModalOpen(false);
  };

  return (
    <Modal className="CustomMenuDiningChoiceModal" show={isModalOpen}>
      <div className="modal-control" />
      <Modal.Body className="kale">
        <Typography variant="calafia2" color="primary.dark">
          Hold up!
        </Typography>
        <Typography
          variant="subtitle2"
          color="grey.main"
          className="CustomMenuDiningChoiceModalContent"
        >
          You have custom menu item that is only available for pickup in store. If you would like to
          change your dining choice, your cart will be cleared.
        </Typography>
        <ButtonsRow>
          <Button className="btn-primary" onClick={clearCartClick}>
            Clear cart
          </Button>
          <Button className="btn-primary" onClick={revertDiningChoice}>
            Keep custom menu item
          </Button>
        </ButtonsRow>
      </Modal.Body>
    </Modal>
  );
}

export default CustomMenuDiningChoiceModal;
